<template>
  <div :class="['card', 'binds-py-2', 'binds-px-3', (linear ? 'linear' : ''), (table ? 'table' : '')]">
    <slot/>
  </div>
</template>

<script>
export default {
  name: 'AppCard',
  status: 'prototype',
  release: '1.0.0',
  props: {
    linear: {
      type: Boolean,
      default: false
    },
    table: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.card {
  position: relative;
  display: inline-block;
  width: auto;
  box-sizing: border-box;
  background-color: $color-white;
  border-radius: 15px;
  box-shadow: $shadow-l;
  overflow: hidden;

  @include clear-both();

  &.linear {
    display: block;
    width: 100%;
  }

  &.table {
    display: block;
    width: 100%;
    margin-bottom: 1px;
  }
}
</style>
